module.exports = __webpack_public_path__ + "img/chinesecompany133.9fbd57cb.png";